<ng-container *ngIf="initialized">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Presenter Details</h5>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-3">
          <img class="img-fluid rounded-circle mr-1" [fallback]="'fetch-avatar?userId=' + user.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ user.id }}-avatar.png"   />
        </div>
        <div class="col-md-9">
          <h3>{{ user.fullNameWithCredentials }}</h3>
          <strong class="d-block">{{ user.affiliation }}</strong>
          <strong class="d-block">{{ user.organizationalTitle }}</strong>
          <strong class="d-block"
            ><a href="mailto:{{ user.email }}"> {{ user.email }}</a>
          </strong>
          <strong class="d-block">{{ user.phoneNumber | phone }}</strong>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <div [editorHTML]="user.biography"></div>
        </div>
      </div>
      <div *ngIf="otherPapers.length > 0" class="row mt-5">
        <div class="col-md-12">
          <h5>Other Papers</h5>
          <ul>
            <li *ngFor="let paper of otherPapers"><a [routerLink]="['../',paper.id]" target="_blank" [relativeTo]="route"> {{ paper.title }}</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row ml-auto">
        <div class="col-md-12">
          <button class="btn btn-sm btn-outline-dark ml-auto" (click)="onCancel()" type="button">Close</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
